import { Form, Formik } from 'formik';
import React, { useRef, useState } from 'react'
import { FormCheckbox, FormInput, FormSelector } from '../../FormElements';
import FormObserver from '../../FormElements/FormObserver';
import { getSendOptionById, sendOptions } from '../../../../constants/options/sendOptions';
import { getExpireDateById, paymentLinkDates } from '../../../../constants/options/linkExpireDates';
import Button from '../../Elements/Button';
import { useDispatch } from 'react-redux';
import commonNetwork, { baseApiUrl } from '../../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { getBankList } from '../../../../store/slices/bankListSlice';
import { getErpParameters } from '../../../../store/slices/erpParameterSlice';
import { getParameters } from '../../../../store/slices/parametersSlice';
import { getLinkParameters } from '../../../../store/slices/linkParametersSlice';
import { ThunkDispatch } from 'redux-thunk';
import Contracts from '../Contracts';
import FileUploader from '../../FileUploader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import TenantResolver from '../../TenantResolver';
import { FormControlLabel, Switch } from '@mui/material';
import { generalSettingsSchema } from '../../../../common/validators/generalSettingsSchema';
import { getInvoicePaymentFormExpireOptionById, invoicePaymentFormExpireDates } from '../../../../constants/options/invoicePaymentFormExpireDates';
import { getInvoicePaymentFormPaymentTypeOptionById, invoicePaymentFormPaymentType } from '../../../../constants/options/invoicePaymentFormPaymentType';
interface GeneralSettingsProp {
    vpList: any,
    parameters: any,
    contractsState: any
}

const GeneralSettings: React.FC<GeneralSettingsProp> = ({
    vpList,
    parameters,
    contractsState
}) => {

    const initialValues = {
        isCurrency: parameters?.isCurrency,
        advanceDirectSubs: parameters?.isPaymentRouteZeroInstallment,
        advanceDirectSubsBank: parameters?.routeZeroInstallmentBank,
        isPublicPaymnet: parameters?.ispublicpayment,
        minAmount: parameters?.ispublicpayment == false ? 0.00 : parameters?.minAmount,
        isShowInstallment: parameters?.isShowInstallment,
        sendMethod: parameters?.sendTypeId,
        linkExpiryDate: parameters?.linkExpiryDate,
        firmLogoPath: parameters?.firmLogoPath,
        isBankComission: parameters?.isBankComission,
        isPaymentDisable: parameters?.isPaymentDisable,
        invoiceExpireDate: parameters?.invoiceExpireDate || 5,
        invoicePaymentType: parameters?.invoicePaymentType || 1,
    }

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const [formValues, setFormValues] = useState(initialValues);
    const [isloadingParameters, setIsloadingParameters] = useState<boolean>(false);
    const [firmLogoUrl, setFirmLogoUrl] = useState<any>();
    const [isTenantUpdated, setIsTenantUpdated] = useState<boolean>(false);

    const onSubmit = async (values: any) => {
        setIsloadingParameters(true);
        const formData = new FormData();
        const formObject = {
            isPaymentRouteZeroInstallment: values.advanceDirectSubs,
            routeZeroInstallmentBank: values.advanceDirectSubsBank,
            sendTypeId: values.sendMethod,
            LinkExpiryDate: values.linkExpiryDate,
            minAmount: values.minAmount && values.minAmount.includes('.') 
                ? values.minAmount 
                : "0.00",
            ispublicpayment: values.isPublicPaymnet,
            isShowInstallment: values.isShowInstallment,
            isCurrency: values.isCurrency,
            isBankComission: values.isBankComission,
            isPaymentDisable: values.isPaymentDisable,
            invoicePaymentType: values.invoicePaymentType,
            invoiceExpireDate: values.invoiceExpireDate,
        };

        Object.entries(formObject).forEach(([key, value]) => {
            formData.append(key, value);
        });
        formData.append("firmLogo", firmLogoUrl);
        const response = await commonNetwork.postFormData(
            "/parameters/saveGeneralParameter-v1",
            formData
        );

        if (response.isSuccess) {
            dispatch(getBankList());
            dispatch(getErpParameters());
            dispatch(getParameters());
            dispatch(getLinkParameters());
            setIsTenantUpdated(prev => !prev);
            toast.success("Kayıt işlemi başarılı");
        } else {
            toast.error("Kayıt işlemi başarısız");
        }
        setIsloadingParameters(false);
    };

    const getBankItem = (id: any) => {
        var index = vpList.findIndex((w: any) => w.value == id);
        if (index != -1) {
            return vpList[index];
        }
    };

    // Tenant tetikleme sonrası state güncelleme
    const handleTenantUpdated = () => {
        setIsTenantUpdated(false);
    };

    const getFirmLogoImage = () => {

        let url = "";
        if (formValues.firmLogoPath?.length == 0 && firmLogoUrl) {
            url = URL.createObjectURL(firmLogoUrl);
        } else {
            url = baseApiUrl + "/Uploads/firm_logos/" + formValues.firmLogoPath;
        }

        return (
            <div className="dropzone bg-white flex justify-center items-center dark:bg-gray-800 rounded-md border-2 border-dashed border-gray-200 dark:border-gray-700 min-h-[130px]">
                <img
                    src={url}
                    width={75}
                    height={75}
                />
                <button
                    className="inline-flex flex-shrink-0 justify-center items-center h-8 w-8 "
                    type="button"
                    onClick={() => {
                        setFirmLogoUrl('');
                        setFormValues({
                            ...formValues,
                            firmLogoPath: ""
                        });
                    }
                    }
                >
                    <FontAwesomeIcon className='text-3xl text-danger ml-4' icon={faXmark} />
                </button>
            </div>
        );

    }

    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={onSubmit}
                validationSchema={generalSettingsSchema}
            >
                {({
                    values,
                    setFieldValue,
                }) => (
                    <Form>
                        <FormObserver
                            watch={(val: any) => {
                                setFormValues(val);
                            }}
                        />

                        <div className="px-4  py-2  bg-white shadow-md space-y-4  mt-2 rounded-md">
                            <div className="my-1">
                                <div className=" px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4">
                                    <div className="mt-3">
                                        <h1 className="font-bold text-contrast-90">
                                            Genel Ayarlar
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            
                                        </span>
                                        {/* <div className='flex justify-center mr-16'>
                                            <div className='relative pt-4 h-[200px] w-[200px]'>
                                                {firmLogoUrl && (
                                                    <img
                                                        src={URL.createObjectURL(firmLogoUrl)}
                                                        alt="firmLogo"
                                                        className='h-[180px] w-[180px] rounded-full'
                                                    />
                                                )}
 
                                                    <button
                                                        type='submit'
                                                        className='bg-white flex-center absolute bottom-3 right-8 h-9 rounded-full'
                                                        onClick={handleImageUpload}
                                                    > 
                                                        {!firmLogoUrl &&(
                                                              <img width="70" height="70" src="/images/upload-image.png" />
                                                        )}
                                                    </button>
                                                    <input
                                                        type='file'
                                                        id='file'
                                                        ref={fileUploadRef}
                                                        onChange={uploadImageDisplay}
                                                        hidden
                                                    /> 
                                            </div>
                                        </div> */}
                                        <div className="grid lg:grid-cols-1 gap-4 mb-5 mt-5 pr-10">
                                            {formValues.firmLogoPath || firmLogoUrl ? getFirmLogoImage() : (
                                                <FileUploader
                                                    isSingleFile
                                                    showPreview
                                                    isImageOnly
                                                    icon="text-4xl text-gray-300 dark:text-gray-200"
                                                    text="Firma Logonuzu Yükleyiniz."
                                                    extraText="PNG, JPG ve JPEG formatında tek bir görsel yüklenebilir."
                                                    onFileUpload={(file) =>
                                                        setFirmLogoUrl(file[0])
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="w-full col-span-2">
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className=''>
                                                <FormControlLabel
                                                    className={`flex flex-row justify-end font-small ${formValues.isPaymentDisable == true ? "text-gray-400" : "text-success-blue"}`}
                                                    style={{
                                                        marginRight: 0,
                                                        marginLeft: -10,
                                                    }}
                                                    label={<p >{formValues.isPaymentDisable ? "Tüm Ödeme İşlemleri Kapalı" : "Tüm Ödeme İşlemleri Açık"}</p>}
                                                    control={
                                                        <Switch
                                                            style={{
                                                                marginRight: 0,
                                                            }}
                                                            defaultChecked={formValues.isPaymentDisable == true ? false : true}
                                                            checked={formValues.isPaymentDisable == true ? false : true}
                                                            onChange={(e) => {
                                                                setFormValues(prevValues => ({
                                                                    ...prevValues,
                                                                    isPaymentDisable: formValues.isPaymentDisable == true ? false : true
                                                                }))
                                                            }}
                                                        />
                                                    }>
                                                </FormControlLabel>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className={"mt-3 mb-[35px]"}>
                                                <FormCheckbox
                                                    label={"Peşin İşlemlerde Varsayılan Ödeme Altyapısı Var Mı?"}
                                                    name={"advanceDirectSubs"}
                                                    id="advanceDirectSubs"
                                                    type="checkbox"
                                                    onChange={setFieldValue}
                                                    defaultValue={values.advanceDirectSubs}
                                                />
                                            </div>
                                            {values.advanceDirectSubs && vpList.length > 0 && (
                                                <div className="mt-2">
                                                    <FormSelector
                                                        label={"Peşin Yönlendirme Altyapısı"}
                                                        name={"advanceDirectSubsBank"}
                                                        options={vpList}
                                                        defaultValue={getBankItem(
                                                            formValues.advanceDirectSubsBank
                                                        )}
                                                        onChange={setFieldValue}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        {
                                            parameters.isWebPackage &&
                                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                                <>
                                                    <div className="mt-3 mb-5">
                                                        <FormCheckbox
                                                            label={"Üyeliksiz Ödeme Var Mı ?"}
                                                            name={"isPublicPaymnet"}
                                                            id="isPublicPaymnet"
                                                            type="checkbox"
                                                            onChange={setFieldValue}
                                                            defaultValue={values.isPublicPaymnet}
                                                        />
                                                        <span className="px-6 sm:px-6 text-contrast-50 text-left text-xs ">
                                                            * Bu özellik sadece e-Tahsilat WEB ve B2B paketleri için geçerlidir.
                                                        </span>
                                                    </div>
                                                    {
                                                        values.isPublicPaymnet && (
                                                            <div className="mt-3">
                                                                <FormInput
                                                                    label={"Üyeliksiz Ödeme İçin Minumum Ödeme Tutarı"}
                                                                    name={"minAmount"}
                                                                    currencyformat="true"
                                                                    currencyicon="true"
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            </div>
                                        }
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className="mt-3">
                                                <FormSelector
                                                    label={"Varsayılan Ödeme Linki Gönderim Şekli"}
                                                    name={"sendMethod"}
                                                    options={sendOptions}
                                                    defaultValue={getSendOptionById(
                                                        formValues.sendMethod
                                                    )}
                                                    onChange={setFieldValue}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <FormSelector
                                                    label={"Varsayılan Ödeme Linki Geçerlilik Süresi"}
                                                    name={"linkExpiryDate"}
                                                    placeholder="Link Geçerlilik Süresi"
                                                    options={paymentLinkDates}
                                                    defaultValue={getExpireDateById(
                                                        formValues.linkExpiryDate
                                                    )}
                                                    onChange={setFieldValue}
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className="mt-3">
                                                <FormSelector
                                                    label={"e-Fatura Ödeme Linki Ödeme Yöntemi"}
                                                    name={"invoicePaymentType"}
                                                    options={invoicePaymentFormPaymentType}
                                                    defaultValue={getInvoicePaymentFormPaymentTypeOptionById(
                                                        formValues.invoicePaymentType || 1
                                                    )}
                                                    onChange={setFieldValue}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <FormSelector
                                                    label={"e-Fatura Ödeme Linki Geçerlilik Süresi"}
                                                    name={"invoiceExpireDate"}
                                                    options={invoicePaymentFormExpireDates}
                                                    defaultValue={getInvoicePaymentFormExpireOptionById(
                                                        formValues.invoiceExpireDate || 5
                                                    )}
                                                    onChange={setFieldValue}
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className="mt-6">
                                                <FormCheckbox
                                                    label={"Ödeme Sayfasında Taksit Listesi Gösterilsin"}
                                                    name={"isShowInstallment"}
                                                    id="isShowInstallment"
                                                    type="checkbox"
                                                    onChange={setFieldValue}
                                                    defaultValue={values.isShowInstallment}
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className='mt-6'>
                                                <FormCheckbox
                                                    label="Komisyon Tutarı Banka Hesabına Göre Hesaplansın"
                                                    name="isBankComission"
                                                    id="isBankComission"
                                                    type="checkbox"
                                                    onChange={setFieldValue}
                                                    defaultValue={values.isBankComission}
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                            <div className='mt-6'>
                                                <FormCheckbox
                                                    label="Dövizli Pos Kullanılsın"
                                                    name="isCurrency"
                                                    id="isCurrency"
                                                    type="checkbox"
                                                    onChange={setFieldValue}
                                                    defaultValue={values.isCurrency}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4  w-full justify-end flex flex-row">
                                <Button
                                    size="xl"
                                    color="primary"
                                    hover="primary"
                                    type="submit"
                                    loading={isloadingParameters}
                                >
                                    Kaydet
                                </Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <Contracts contracts={contractsState}></Contracts>
            {/* TenantResolver'ı tetiklemek için */}
            {isTenantUpdated && <TenantResolver onTenantUpdate={handleTenantUpdated} />}
        </div>
    )
}

export default GeneralSettings;